export default __webpack_public_path__ + "static/media/placeholder2.054843c8.jpg";